import { action, computed, observable } from 'mobx';

import { getCollectionByCollectionName } from '~api/CollectionsAPI/CollectionsAPI';
import { findCollectionInCollectionResponse } from '~api/CollectionsAPI/mappers/FindCollectionMapper';
import { ICollection } from '~domain/entities/Collection/ICollection';

export interface ICollections {
    [key: string]: ICollection;
}

export class CollectionRepository {
    @observable private _collections: ICollections = {};
    @observable private _isLoading: boolean = false;

    @action public updateCollectionByName = (collectionName: string) => {
        this._isLoading = true;

        return getCollectionByCollectionName(collectionName)
            .then((data) => {
                const collection = findCollectionInCollectionResponse(collectionName, data);
                this._collections[collectionName] = collection;

                return collection;
            })
            .finally(() => {
                this._isLoading = false;
            });
    };

    @action public getCollection = (collectionName: string) => {
        const foundCollection = this._collections[collectionName];

        if (!foundCollection) {
            this.updateCollectionByName(collectionName);
        }

        return foundCollection || [];
    };

    @computed public get isLoading() {
        return this._isLoading;
    }
}
